import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pin--sprite",
  "use": "pin--sprite-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"pin--sprite\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.886 1.59l.779.779-4.925 3.56-.892-.891-.707.707L6.97 8.573l-4.738 4.738-.212.92.92-.213L7.676 9.28l1.334 1.334.301.301 1.193 1.194.707-.707-.892-.892 3.561-4.925.778.779.708-.708-1.194-1.193-2.386-2.386L10.594.883l-.708.708zm-3.43 5.056l4.925-3.56 1.784 1.783-3.56 4.925L8.03 8.22 6.457 6.646z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol